import { Component } from 'react';
import { connect } from 'react-redux';
import api from 'api';
import { actions } from 'store';
import { breakpoints } from 'styles';
import { Button } from 'components/common';
import { Box } from 'components/common/box';
import { Form, FormGroup, Select } from 'components/common/form';
import { PathAccessSignUpLink } from 'components/paths';

const PathAccess = connect((state) => state)(
  class extends Component {
    state = {
      loading: false,
      pristine: true
    };

    handleChange = () => {
      this.setState({ pristine: false });
    };

    setFormApi = (formApi) => {
      this.formApi = formApi;
    };

    submit = async (values) => {
      const {
        dispatch,
        messages,
        pageState: { path }
      } = this.props;

      try {
        this.setState({ loading: true });
        await api.put(`/admin/paths/${path.id}`, {
          userAccess: values.userAccess
        });
        this.setState({ loading: false, pristine: true });
        dispatch(
          actions.addNotice({
            text: messages.settingsSavedSuccessfully,
            type: 'success'
          })
        );
      } catch (err) {
        this.setState({ loading: false });
        await dispatch.handleErrorDispatch(err);
      }
    };

    render() {
      const {
        messages,
        pageState: { path },
        serverConfig
      } = this.props;
      const { loading, pristine } = this.state;

      const { authStrategies, isDemoEnvironment, pathEnableSignUpLink } =
        serverConfig;

      const initialValues = {
        userAccess: path.userAccess
      };

      return (
        <div className="settings">
          <div className="content-container">
            <Box title={messages.commonAccess}>
              <Form
                getApi={this.setFormApi}
                initialValues={initialValues}
                onSubmit={this.submit}
              >
                {() => (
                  <div>
                    <FormGroup
                      htmlFor="user-access"
                      label={messages.pathsAccess}
                      style={{ width: 260, maxWidth: '100%' }}
                    >
                      <Select
                        field="userAccess"
                        id="user-access"
                        onChange={this.handleChange}
                        options={[
                          {
                            label: messages.settingsAddedUsersOnly,
                            value: 'added-only'
                          },
                          ...(authStrategies?.length
                            ? [
                                {
                                  label: messages.settingsSingleSignOnUsers,
                                  value: 'sso'
                                }
                              ]
                            : []),
                          {
                            label: messages.settingsRegistered,
                            value: 'registered',
                            isDisabled: isDemoEnvironment
                          }
                        ]}
                      />
                    </FormGroup>

                    <FormGroup>
                      <Button
                        category="success"
                        disabled={pristine}
                        loading={loading}
                        text={messages.commonSave}
                        type="submit"
                      />
                    </FormGroup>
                  </div>
                )}
              </Form>
            </Box>

            <PathAccessSignUpLink />
          </div>
          <style jsx>{`
            .content-container {
              max-width: 100%;
              ${pathEnableSignUpLink
                ? `
                display: grid;
                grid-template-columns: 1fr 1fr;
                grid-gap: 20px;
                @media (max-width: ${breakpoints.large}px) {
                  grid-template-columns: 1fr;
                }
              `
                : ''}
            }
          `}</style>
        </div>
      );
    }
  }
);

export default PathAccess;
